import { render, staticRenderFns } from "./ResultsTableView.vue?vue&type=template&id=70051bf8"
import script from "./ResultsTableView.vue?vue&type=script&lang=js"
export * from "./ResultsTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports